import React, { useContext } from 'react';
import { closestCorners, DndContext } from '@dnd-kit/core';
import { SortableContext } from '@dnd-kit/sortable';
import { StrategyPerSlotContext } from '@/features/editor/widgets/custom-widget/loading-section/strategy-per-slot/context/context';
import { LoadingStrategyOption } from '@/webapi/use-widget-catalog-api';
import { Slot } from '@/features/editor/widgets/custom-widget/loading-section/shared/slot';

export function SlotsList() {
  const ctx = useContext(StrategyPerSlotContext);
  if (
    ctx.isProductSearchOpen ||
    ctx.isProductCondOpen ||
    ctx.isManualImageSelectionOpen ||
    ctx.isGlobalFilterOpen
  ) {
    return null;
  }

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (over && active.id === over.id) return;
    ctx.changeNumForSlot(active.id, over.id);
  };
  const sortableItems = ctx.state.slots.map((s) => ({
    ...s,
    id: s.num,
  }));
  return (
    <DndContext collisionDetection={closestCorners} onDragEnd={handleDragEnd}>
      <SortableContext items={sortableItems}>
        {ctx.state.slots.map((slot, index) => {
          const onProductSelect = () => ctx.setProductSearchSlotOpen(slot.num);
          const onStrategySelect = (value: LoadingStrategyOption) => () =>
            ctx.selectStrategyForSlot(value.value.type, slot.num);
          const onDuplicateSelect = (num: number) => () =>
            ctx.duplicateSlot(num, slot.num);
          const onDelete = () => ctx.clearSlot(slot.num);
          const onMoreFilters = () => ctx.setProductCondSlotOpen(slot.num);
          return (
            <Slot
              key={slot.num}
              slot={slot}
              onProductSelect={onProductSelect}
              onStrategySelect={onStrategySelect}
              onDuplicateSelect={onDuplicateSelect}
              onDelete={onDelete}
              onMoreFilters={onMoreFilters}
              index={index}
              slots={ctx.state.slots}
            />
          );
        })}
      </SortableContext>
    </DndContext>
  );
}
